export const FETCH_PERSONALS_LIST_START = 'FETCH_PERSONALS_LIST_START';
export const FETCH_PERSONALS_LIST_ERROR = 'FETCH_PERSONALS_LIST_ERROR';
export const RECEIVE_PERSONALS_LIST = 'RECEIVE_PERSONALS_LIST';
export const CLEAR_PERSONALS_LIST_STORE = 'CLEAR_PERSONALS_LIST_STORE';

export const FETCH_PERSONAL_PROFILE_START = 'FETCH_PERSONAL_PROFILE_START';
export const FETCH_PERSONAL_PROFILE_ERROR = 'FETCH_PERSONAL_PROFILE_ERROR';
export const FETCH_PERSONAL_PROFILE_NOT_FOUND = 'FETCH_PERSONAL_PERSONALAL_NOT_FOUND';
export const RECEIVE_PERSONAL_PROFILE = 'RECEIVE_PERSONAL_PROFILE';
export const SAVE_PERSONAL_PROFILE_START = 'SAVE_PERSONAL_PROFILE_START';
export const SAVE_PERSONAL_PROFILE_ERROR = 'SAVE_PERSONAL_PROFILE_ERROR';
export const SAVE_PERSONAL_PROFILE_SUCCESSFUL = 'SAVE_PERSONAL_PROFILE_SUCCESSFUL';
export const CLEAR_PERSONAL_PROFILE_STORE = 'CLEAR_PERSONAL_PROFILE_STORE';
export const ADD_PERSONAL_START = 'ADD_PERSONAL_START';
export const ADD_PERSONAL_ERROR = 'ADD_PERSONAL_ERROR';
export const ADD_PERSONAL_SUCCESSFUL = 'ADD_PERSONAL_DONE';
export const SAVE_PERSONAL_PROFILE_PICTURE_START = 'SAVE_PERSONAL_PROFILE_PICTURE_START';
export const SAVE_PERSONAL_PROFILE_PICTURE_ERROR = 'SAVE_PERSONAL_PROFILE_PICTURE_ERROR';
export const SAVE_PERSONAL_PROFILE_PICTURE_DONE = 'SAVE_PERSONAL_PROFILE_PICTURE_DONE';
export const REMOVE_PERSONAL_PROFILE_PICTURE_START = 'REMOVE_PERSONAL_PROFILE_PICTURE_START';
export const REMOVE_PERSONAL_PROFILE_PICTURE_ERROR = 'REMOVE_PERSONAL_PROFILE_PICTURE_ERROR';
export const REMOVE_PERSONAL_PROFILE_PICTURE_DONE = 'REMOVE_PERSONAL_PROFILE_PICTURE_DONE';

export const FETCH_PERSONAL_PROGRAMS_START = 'FETCH_PERSONAL_PROGRAMS_START';
export const FETCH_PERSONAL_PROGRAMS_ERROR = 'FETCH_PERSONAL_PROGRAMS_ERROR';
export const RECEIVE_PERSONAL_PROGRAMS = 'RECEIVE_PERSONAL_PROGRAMS';
export const CLEAR_PERSONAL_PROGRAMS_STORE = 'CLEAR_PERSONAL_PROGRAMS_STORE';
export const ADD_PERSONAL_ASSIGNED_PROGRAM_TO_PROGRAMS = 'ADD_PERSONAL_ASSIGNED_PROGRAM_TO_PROGRAMS';

export const FETCH_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_START = 'FETCH_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_START';
export const FETCH_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_ERROR = 'FETCH_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_ERROR';
export const RECEIVE_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST = 'RECEIVE_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST';
export const CLEAR_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_STORE = 'CLEAR_PERSONALS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_STORE';

export const FETCH_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START = 'FETCH_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START';
export const FETCH_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR = 'FETCH_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR';
export const RECEIVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED = 'RECEIVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED';
export const CLEAR_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_STORE = 'CLEAR_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_STORE';
export const SAVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START = 'SAVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START';
export const SAVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_SUCCESSFUL = 'SAVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_SUCCESSFUL';
export const SAVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR = 'SAVE_PERSONAL_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR';

export const FETCH_PERSONAL_CATEGORY_START = 'FETCH_PERSONAL_CATEGORY_START';
export const FETCH_PERSONAL_CATEGORY_ERROR = 'FETCH_PERSONAL_CATEGORY_ERROR';
export const FETCH_PERSONAL_CATEGORY_NOT_FOUND = 'FETCH_PERSONAL_CATEGORY_NOT_FOUND';
export const RECEIVE_PERSONAL_CATEGORY = 'RECEIVE_PERSONAL_CATEGORY';
export const CLEAR_PERSONAL_CATEGORY_STORE = 'CLEAR_PERSONAL_CATEGORY_STORE';
export const SAVE_PERSONAL_CATEGORY_START = 'SAVE_PERSONAL_CATEGORY_START';
export const SAVE_PERSONAL_CATEGORY_SUCCESSFUL = 'SAVE_PERSONAL_CATEGORY_SUCCESSFUL';
export const SAVE_PERSONAL_CATEGORY_ERROR = 'SAVE_PERSONAL_CATEGORY_ERROR';

export const FETCH_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_START = 'FETCH_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_START';
export const FETCH_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_ERROR = 'FETCH_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_ERROR';
export const FETCH_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_NOT_FOUND = 'FETCH_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_NOT_FOUND';
export const RECEIVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS = 'RECEIVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS';
export const CLEAR_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_STORE = 'CLEAR_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_STORE';
export const SAVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_START = 'SAVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_START';
export const SAVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_SUCCESSFUL = 'SAVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_SUCCESSFUL';
export const SAVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_ERROR = 'SAVE_PERSONAL_SETTINGS_TRACKED_MEASUREMENTS_ERROR';

export const FETCH_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_START = 'FETCH_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_START';
export const FETCH_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_ERROR = 'FETCH_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_ERROR';
export const FETCH_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_NOT_FOUND = 'FETCH_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_NOT_FOUND';
export const RECEIVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL = 'RECEIVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL';
export const CLEAR_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_STORE = 'CLEAR_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_STORE';
export const SAVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_START = 'SAVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_START';
export const SAVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_SUCCESSFUL = 'SAVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_SUCCESSFUL';
export const SAVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_ERROR = 'SAVE_PERSONAL_SETTINGS_MEASUREMENTS_GENERAL_ERROR';

export const FETCH_PERSONAL_MEASUREMENTS_START = 'FETCH_PERSONAL_MEASUREMENTS_START';
export const FETCH_PERSONAL_MEASUREMENTS_ERROR = 'FETCH_PERSONAL_MEASUREMENTS_ERROR';
export const RECEIVE_PERSONAL_MEASUREMENTS = 'RECEIVE_PERSONAL_MEASUREMENTS';
export const CLEAR_PERSONAL_MEASUREMENTS_STORE = 'CLEAR_PERSONAL_MEASUREMENTS_STORE';
export const ADD_PERSONAL_MEASUREMENT_START = 'ADD_PERSONAL_MEASUREMENT_START';
export const ADD_PERSONAL_MEASUREMENT_SUCCESSFUL = 'ADD_PERSONAL_MEASUREMENT_SUCCESSFUL';
export const ADD_PERSONAL_MEASUREMENT_ERROR = 'ADD_PERSONAL_MEASUREMENT_ERROR';
export const EDIT_PERSONAL_MEASUREMENT_START = 'EDIT_PERSONAL_MEASUREMENT_START';
export const EDIT_PERSONAL_MEASUREMENT_SUCCESSFUL = 'EDIT_PERSONAL_MEASUREMENT_SUCCESSFUL';
export const EDIT_PERSONAL_MEASUREMENT_ERROR = 'EDIT_PERSONAL_MEASUREMENT_ERROR';
export const DELETE_PERSONAL_MEASUREMENT_START = 'DELETE_PERSONAL_MEASUREMENT_START';
export const DELETE_PERSONAL_MEASUREMENT_SUCCESSFUL = 'DELETE_PERSONAL_MEASUREMENT_SUCCESSFUL';
export const DELETE_PERSONAL_MEASUREMENT_ERROR = 'DELETE_PERSONAL_MEASUREMENT_ERROR';

export const FETCH_PERSONAL_MEASUREMENT_START = 'FETCH_PERSONAL_MEASUREMENT_START';
export const FETCH_PERSONAL_MEASUREMENT_ERROR = 'FETCH_PERSONAL_MEASUREMENT_ERROR';
export const FETCH_PERSONAL_MEASUREMENT_NOT_FOUND = 'FETCH_PERSONAL_MEASUREMENT_NOT_FOUND';
export const RECEIVE_PERSONAL_MEASUREMENT = 'RECEIVE_PERSONAL_MEASUREMENT';
export const CLEAR_PERSONAL_MEASUREMENT_STORE = 'CLEAR_PERSONAL_MEASUREMENT_STORE';

export const ASSIGN_PERSONAL_PROGRAM_START = 'ASSIGN_PERSONAL_PROGRAM_START';
export const ASSIGN_PERSONAL_PROGRAM_SUCCESSFUL = 'ASSIGN_PERSONAL_PROGRAM_SUCCESSFUL';
export const ASSIGN_PERSONAL_PROGRAM_ERROR = 'ASSIGN_PERSONAL_PROGRAM_ERROR';
export const CLEAR_ASSIGN_PERSONAL_PROGRAM_STORE = 'CLEAR_ASSIGN_PERSONAL_PROGRAM_STORE';

export const ADD_MEASUREMENT_TO_PERSONAL_MEASUREMENTS = 'ADD_MEASUREMENT_TO_PERSONAL_MEASUREMENTS';
export const EDIT_MEASUREMENT_TO_PERSONAL_MEASUREMENTS = 'EDIT_MEASUREMENT_TO_PERSONAL_MEASUREMENTS';
export const DELETE_MEASUREMENT_FROM_PERSONAL_MEASUREMENTS = 'DELETE_MEASUREMENT_FROM_PERSONAL_MEASUREMENTS';

export const FETCH_PERSONAL_LIFE_STAGES_LIST_START = 'FETCH_PERSONAL_LIFE_STAGES_LIST_START';
export const FETCH_PERSONAL_LIFE_STAGES_LIST_ERROR = 'FETCH_PERSONAL_LIFE_STAGES_LIST_ERROR';
export const RECEIVE_PERSONAL_LIFE_STAGES_LIST = 'RECEIVE_PERSONAL_LIFE_STAGES_LIST';
export const CLEAR_PERSONAL_LIFE_STAGES_LIST_STORE = 'CLEAR_PERSONAL_LIFE_STAGES_LIST_STORE';

export const CREATE_PERSONAL_PROGRAM_START = 'CREATE_PERSONAL_PROGRAM_START';
export const CREATE_PERSONAL_PROGRAM_SUCCESSFUL = 'CREATE_PERSONAL_PROGRAM_SUCCESSFUL';
export const CREATE_PERSONAL_PROGRAM_ERROR = 'CREATE_PERSONAL_PROGRAM_ERROR';
export const CLEAR_CREATE_PERSONAL_PROGRAM_STORE = 'CLEAR_CREATE_PERSONAL_PROGRAM_STORE';

export const SET_EVOLUTION_CONFIGURED = 'SET_EVOLUTION_CONFIGURED';

export const PERSONAL_EMAIL_CHANGE_START = 'PERSONAL_EMAIL_CHANGE_START';
export const PERSONAL_EMAIL_CHANGE_ERROR = 'PERSONAL_EMAIL_CHANGE_ERROR';
export const PERSONAL_EMAIL_CHANGE_SUCCESSFUL = 'PERSONAL_EMAIL_CHANGE_SUCCESSFUL';
export const CLEAR_PERSONAL_EMAIL_CHANGE_STORE = 'CLEAR_PERSONAL_EMAIL_CHANGE_STORE';

export const PERSONAL_EMAIL_VERIFY_START = 'PERSONAL_EMAIL_VERIFY_START';
export const PERSONAL_EMAIL_VERIFY_ERROR = 'PERSONAL_EMAIL_VERIFY_ERROR';
export const PERSONAL_EMAIL_VERIFY_SUCCESSFUL = 'PERSONAL_EMAIL_VERIFY_SUCCESSFUL';
export const CLEAR_PERSONAL_EMAIL_VERIFY_STORE = 'CLEAR_PERSONAL_EMAIL_VERIFY_STORE';

export const CHANGE_PERSONAL_PROFILE_EMAIL = 'CHANGE_PERSONAL_PROFILE_EMAIL';

export const CHANGE_PERSONAL_PASSWORD_START = 'CHANGE_PERSONAL_PASSWORD_START';
export const CHANGE_PERSONAL_PASSWORD_ERROR = 'CHANGE_PERSONAL_PASSWORD_ERROR';
export const CHANGE_PERSONAL_PASSWORD_SUCCESSFUL = 'CHANGE_PERSONAL_PASSWORD_SUCCESSFUL';
export const CLEAR_PERSONAL_PASSWORD_STORE = 'CLEAR_PERSONAL_PASSWORD_STORE';

export const FETCH_PERSONAL_BIOGRAPHY_START = 'FETCH_PERSONAL_BIOGRAPHY_START';
export const FETCH_PERSONAL_BIOGRAPHY_ERROR = 'FETCH_PERSONAL_BIOGRAPHY_ERROR';
export const RECEIVE_PERSONAL_BIOGRAPHY = 'RECEIVE_PERSONAL_BIOGRAPHY';
export const ADD_PERSONAL_EDUCATION_IN_BIOGRAPHY = 'ADD_PERSONAL_EDUCATION_IN_BIOGRAPHY';
export const UPDATE_PERSONAL_EDUCATION_IN_BIOGRAPHY = 'UPDATE_PERSONAL_EDUCATION_IN_BIOGRAPHY';
export const REMOVE_PERSONAL_EDUCATION_FROM_BIOGRAPHY = 'REMOVE_PERSONAL_EDUCATION_FROM_BIOGRAPHY';
export const ADD_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY = 'ADD_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY';
export const UPDATE_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY = 'UPDATE_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY';
export const REMOVE_PROFESSIONAL_EXPERIENCE_FROM_BIOGRAPHY = 'REMOVE_PROFESSIONAL_EXPERIENCE_FROM_BIOGRAPHY';
export const CLEAR_PERSONAL_BIOGRAPHY_STORE = 'CLEAR_PERSONAL_BIOGRAPHY_STORE';

export const GET_PERSONAL_EDUCATION_START = 'GET_PERSONAL_EDUCATION_START';
export const GET_PERSONAL_EDUCATION_ERROR = 'GET_PERSONAL_EDUCATION_ERROR';
export const GET_PERSONAL_EDUCATION_SUCCESSFUL = 'GET_PERSONAL_EDUCATION_SUCCESSFUL';
export const CLEAR_PERSONAL_EDUCATION_STORE = 'CLEAR_PERSONAL_EDUCATION_STORE';
export const ADD_PERSONAL_EDUCATION_START = 'ADD_PERSONAL_EDUCATION_START';
export const ADD_PERSONAL_EDUCATION_SUCCESSFUL = 'ADD_PERSONAL_EDUCATION_SUCCESSFUL';
export const ADD_PERSONAL_EDUCATION_ERROR = 'ADD_PERSONAL_EDUCATION_ERROR';
export const EDIT_PERSONAL_EDUCATION_START = 'EDIT_PERSONAL_EDUCATION_START';
export const EDIT_PERSONAL_EDUCATION_SUCCESSFUL = 'EDIT_PERSONAL_EDUCATION_SUCCESSFUL';
export const EDIT_PERSONAL_EDUCATION_ERROR = 'EDIT_PERSONAL_EDUCATION_ERROR';
export const REMOVE_PERSONAL_EDUCATION_START = 'REMOVE_PERSONAL_EDUCATION_START';
export const REMOVE_PERSONAL_EDUCATION_SUCCESSFUL = 'REMOVE_PERSONAL_EDUCATION_SUCCESSFUL';
export const REMOVE_PERSONAL_EDUCATION_ERROR = 'REMOVE_PERSONAL_EDUCATION_ERROR';

export const GET_PROFESSIONAL_EXPERIENCE_START = 'GET_PROFESSIONAL_EXPERIENCE_START';
export const GET_PROFESSIONAL_EXPERIENCE_ERROR = 'GET_PROFESSIONAL_EXPERIENCE_ERROR';
export const GET_PROFESSIONAL_EXPERIENCE_SUCCESSFUL = 'GET_PROFESSIONAL_EXPERIENCE_SUCCESSFUL';
export const CLEAR_PROFESSIONAL_EXPERIENCE_STORE = 'CLEAR_PROFESSIONAL_EXPERIENCE_STORE';
export const ADD_PROFESSIONAL_EXPERIENCE_START = 'ADD_PROFESSIONAL_EXPERIENCE_START';
export const ADD_PROFESSIONAL_EXPERIENCE_SUCCESSFUL = 'ADD_PROFESSIONAL_EXPERIENCE_SUCCESSFUL';
export const ADD_PROFESSIONAL_EXPERIENCE_ERROR = 'ADD_PROFESSIONAL_EXPERIENCE_ERROR';
export const EDIT_PROFESSIONAL_EXPERIENCE_START = 'EDIT_PROFESSIONAL_EXPERIENCE_START';
export const EDIT_PROFESSIONAL_EXPERIENCE_SUCCESSFUL = 'EDIT_PROFESSIONAL_EXPERIENCE_SUCCESSFUL';
export const EDIT_PROFESSIONAL_EXPERIENCE_ERROR = 'EDIT_PROFESSIONAL_EXPERIENCE_ERROR';
export const REMOVE_PROFESSIONAL_EXPERIENCE_START = 'REMOVE_PROFESSIONAL_EXPERIENCE_START';
export const REMOVE_PROFESSIONAL_EXPERIENCE_SUCCESSFUL = 'REMOVE_PROFESSIONAL_EXPERIENCE_SUCCESSFUL';
export const REMOVE_PROFESSIONAL_EXPERIENCE_ERROR = 'REMOVE_PROFESSIONAL_EXPERIENCE_ERROR';

export const FETCH_PERSONAL_SCHEDULES_LIST_START = 'FETCH_PERSONAL_SCHEDULES_LIST_START';
export const FETCH_PERSONAL_SCHEDULES_LIST_ERROR = 'FETCH_PERSONAL_SCHEDULES_LIST_ERROR';
export const RECEIVE_PERSONAL_SCHEDULES_LIST = 'RECEIVE_PERSONAL_SCHEDULES_LIST';
export const CLEAR_PERSONAL_SCHEDULES_LIST_STORE = 'CLEAR_PERSONAL_SCHEDULES_LIST_STORE';

export const GET_PERSONAL_SCHEDULE_DETAILS_START = 'GET_PERSONAL_SCHEDULE_DETAILS_START';
export const GET_PERSONAL_SCHEDULE_DETAILS_ERROR = 'GET_PERSONAL_SCHEDULE_DETAILS_ERROR';
export const GET_PERSONAL_SCHEDULE_DETAILS_SUCCESSFUL = 'GET_PERSONAL_SCHEDULE_DETAILS_SUCCESSFUL';
export const CLEAR_PERSONAL_SCHEDULE_DETAILS_STORE = 'CLEAR_PERSONAL_SCHEDULE_DETAILS_STORE';

export const GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_START = 'GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_START';
export const GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_ERROR = 'GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_ERROR';
export const GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_SUCCESSFUL = 'GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_SUCCESSFUL';
export const CLEAR_PERSONAL_SCHEDULED_DATE_SCHEDULES_STORE = 'CLEAR_PERSONAL_SCHEDULED_DATE_SCHEDULES_STORE';

export const GET_PERSONAL_SCHEDULED_DATES_START = 'GET_PERSONAL_SCHEDULED_DATES_START';
export const GET_PERSONAL_SCHEDULED_DATES_ERROR = 'GET_PERSONAL_SCHEDULED_DATES_ERROR';
export const GET_PERSONAL_SCHEDULED_DATES_SUCCESSFUL = 'GET_PERSONAL_SCHEDULED_DATES_SUCCESSFUL';
export const CLEAR_PERSONAL_SCHEDULED_DATES_STORE = 'CLEAR_PERSONAL_SCHEDULED_DATES_STORE';

export const FETCH_PRE_LOGIN_PERSONAL_PROFILE_START = 'FETCH_PRE_LOGIN_PERSONAL_PROFILE_START';
export const RECEIVE_PRE_LOGIN_PERSONAL_PROFILE = 'RECEIVE_PRE_LOGIN_PERSONAL_PROFILE';
export const FETCH_PRE_LOGIN_PERSONAL_PROFILE_NOT_FOUND = 'FETCH_PRE_LOGIN_PERSONAL_PROFILE_NOT_FOUND';
export const FETCH_PRE_LOGIN_PERSONAL_PROFILE_ERROR = 'FETCH_PRE_LOGIN_PERSONAL_PROFILE_ERROR';

export const FETCH_PERSONAL_ROLES_START = 'FETCH_PERSONAL_ROLES_START';
export const RECEIVE_PERSONAL_ROLES = 'RECEIVE_PERSONAL_ROLES';
export const FETCH_PERSONAL_ROLES_ERROR = 'FETCH_PERSONAL_ROLES_ERROR';
export const CLEAR_PERSONAL_ROLES = 'CLEAR_PERSONAL_ROLES';
export const SET_PERSONAL_ROLES_START = 'SET_PERSONAL_ROLES_START';
export const SET_PERSONAL_ROLES_SUCCESSFUL = 'SET_PERSONAL_ROLES_SUCCESSFUL';
export const SET_PERSONAL_ROLES_ERROR = 'SET_PERSONAL_ROLES_ERROR';

export const FETCH_PERSONAL_STATISTICS_START = 'FETCH_PERSONAL_STATISTICS_START';
export const FETCH_PERSONAL_STATISTICS_ERROR = 'FETCH_PERSONAL_STATISTICS_ERROR';
export const RECEIVE_PERSONAL_STATISTICS = 'RECEIVE_PERSONAL_STATISTICS';
export const CLEAR_PERSONAL_STATISTICS_STORE = 'CLEAR_PERSONAL_STATISTICS_STORE';

export const PERSONAL_DEACTIVATE_ACCOUNT_START = 'PERSONAL_DEACTIVATE_ACCOUNT_START';
export const PERSONAL_DEACTIVATE_ACCOUNT_ERROR = 'PERSONAL_DEACTIVATE_ACCOUNT_ERROR';
export const PERSONAL_DEACTIVATE_ACCOUNT_DONE = 'PERSONAL_DEACTIVATE_ACCOUNT_DONE';

export const PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_START = 'PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_START';
export const PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_ERROR = 'PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_ERROR';
export const PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_SUCCESSFUL = 'PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_SUCCESSFUL';
export const CLEAR_PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_STORE = 'CLEAR_PERSONAL_RESEND_EMAIL_VERIFICATION_TOKEN_STORE';



// WEBPACK FOOTER //
// ./src/store/modules/personal/mutation-types.js